module.exports = __webpack_public_path__ + "static/media/pizza-milano-4.4c48c12e.jpg";